import { buttonTypes } from '@bigin/components/button'
import { Question } from '@bigin/icons-vue'
import { buildProps, definePropType, iconPropType } from '@bigin/utils'
import { useTooltipContentProps } from '@bigin/components/tooltip'
import type { Component, ExtractPropTypes } from 'vue'
import type Popconfirm from './popconfirm.vue'

const popConfirmButtonTypes = [...buttonTypes] as const

export const popconfirmProps = buildProps({
  title: String,
  confirmButtonText: String,
  cancelButtonText: String,
  // confirmButtonType: {
  //   type: String,
  //   values: popConfirmButtonTypes,
  //   default: 'primary',
  // },
  cancelButtonType: {
    type: String,
    values: popConfirmButtonTypes,
    default: 'default',
  },
  icon: {
    type: iconPropType,
    default: Question as Component,
  },
  iconColor: {
    type: String,
    default: '#646464',
  },
  hideIcon: {
    type: Boolean,
    default: false,
  },
  hideAfter: {
    type: Number,
    default: 200,
  },
  onConfirm: {
    type: definePropType<(e: Event) => Promise<void> | void>(Function),
  },
  onCancel: {
    type: definePropType<(e: Event) => Promise<void> | void>(Function),
  },
  teleported: useTooltipContentProps.teleported,
  persistent: useTooltipContentProps.persistent,
  width: {
    type: [String, Number],
    default: 240,
  },
} as const)
export type PopconfirmProps = ExtractPropTypes<typeof popconfirmProps>

export type PopconfirmInstance = InstanceType<typeof Popconfirm>
